import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { Tooltip, makeStyles } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import Pagination from '@material-ui/lab/Pagination';
import { TEACHERS_HOME_URL } from 'config/urls';
import { get, isNil } from 'lodash';
import { useUserSectionsList } from 'sdk';
import { cutText } from 'utils';

import { ReactComponent as RightArrowIcon } from 'pages/Teachers/Home/assets/pointer-icon.svg';
import { trackMixpanelEvent } from 'utils/integrations/mixpanel';
import { parseParams } from 'utils/urls';

import UserContext from 'components/UserContext';

import styles from './styles.module.scss';

const tooltipUseStyles = makeStyles({
  customTooltip: {
    backgroundColor: '#333867',
    color: 'white',
    padding: '8px 12px',
    borderRadius: '4px',
    fontSize: '12px',
    fontFamily: 'Nunito'
  }
});

const SectionsList = () => {
  const { user } = useContext(UserContext);
  const tooltipStyles = tooltipUseStyles();

  const [pagination, setPagination] = useState({
    numPages: 1,
    currentPage: 1,
    limit: 9
  });

  const history = useHistory();
  const searchParams = parseParams(history.location.search);
  const urlPage = get(searchParams, 'currentPage');

  const { data: useUserSections, isLoading: isLoadingSections } =
    useUserSectionsList({
      params: {
        offset: (pagination.currentPage - 1) * pagination.limit,
        limit: pagination.limit
      }
    });

  useEffect(() => {
    if (!isNil(useUserSections)) {
      const { count } = useUserSections;

      setPagination((prev) => ({
        ...prev,
        numPages: Math.ceil(count / prev.limit)
      }));
    }
  }, [useUserSections]);

  useEffect(() => {
    if (!isNil(urlPage)) {
      setPagination((prev) => ({
        ...prev,
        currentPage: parseInt(urlPage)
      }));

      history.replace({
        search: ''
      });
    }
  }, [urlPage, history]);

  const handleItemClick = ({ item }) => {
    trackMixpanelEvent(user.id, 'section_clicked', {
      feature: 'sections_list',
      view: 'home page',
      normalizedURL:
        process.env.REACT_APP_BASE_FRONTEND_URL + TEACHERS_HOME_URL,
      class_name: item.section_name,
      class_id: item.section_id
    });

    // redirect to new section assignemnts page
  };

  const handlePaginationClick = ({ page }) => {
    setPagination((prevPagination) => ({
      ...prevPagination,
      currentPage: page
    }));
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        {isLoadingSections ? (
          <div className={styles.loadingState}>
            <Skeleton variant="rect" width="100%" height={35} />
            <Skeleton variant="rect" width="100%" height={35} />
            <Skeleton variant="rect" width="100%" height={35} />
            <Skeleton variant="rect" width="100%" height={35} />
            <Skeleton variant="rect" width="100%" height={35} />
          </div>
        ) : (
          useUserSections.results.map((item) => (
            <div
              key={item.id}
              className={styles.card}
              onClick={() => handleItemClick({ item })}
            >
              <div className={styles.cardHeader}>
                <Tooltip
                  title={item.name}
                  classes={{ tooltip: tooltipStyles.customTooltip }}
                  disableHoverListener={item.name.length < 70}
                  placement="right"
                >
                  <h3 className={styles.cardTitle}>
                    {cutText({ text: item.name, char: 70 })}
                  </h3>
                </Tooltip>
                <RightArrowIcon />
              </div>
            </div>
          ))
        )}
      </div>
      <div className={styles.paginationContainer}>
        {pagination.numPages > 1 && (
          <div className={styles.pagination}>
            <Pagination
              count={pagination.numPages}
              page={pagination.currentPage}
              color="secondary"
              onChange={(event, page) => handlePaginationClick({ page })}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default SectionsList;
